module.exports = __webpack_public_path__ + "img/profil.c3c3288d.svg";